export default "__VITE_ASSET__z4we2i7z__"